import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import axios from "axios";

class QuestItem extends PureComponent {
  _onSolution = () => {
    const { contentSerial, onSolution, snum } = this.props.childProps;
    onSolution(contentSerial, snum);
  };

  render() {
    const { snum, title } = this.props.childProps;
    return (
      <Fragment>
        <button type="button" onClick={this._onSolution}>
          {snum}. {title}
        </button>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(QuestItem));
